<template>
    <section class="mentor-profile">
        <div class="modal-wrapper" @click.prevent="connect=false" v-if="connect==true">
            <div class="modal-box" @click.stop :style="{ backgroundImage: 'url(' + mentor.featuredImage + ')' }"> <img :src="mentor.avatar" class="avatar">
                <h3>{{mentor.user.firstName}} {{mentor.user.lastName}}</h3> <textarea v-model="request"></textarea>
                <button @click.prevent="sendRequest()" class="btn btn-success">Submit</button>
            </div>
        </div>
        <div class="panel" v-if="mentor">
            <div class="row mentor-header" :style="{ backgroundImage: 'url(' + mentor.featuredImage + ')' }">
                <div class="col-xs-2">
                    <img class="avatar" :src="mentor.avatar">
                </div>
                <div class="col-xs-10">
                    <span class="name">{{mentor.user.firstName}} {{mentor.user.lastName}},&nbsp;</span>
                    <span class="position">
                        {{mentor.position}}
                    </span>
                    <span v-if="mentor.companyUrl">
                        ,&nbsp;
                    </span>
                    <a v-if="mentor.companyUrl" class="company" :href="mentor.companyUrl" target="_blank">
                        {{mentor.company}}
                    </a>
                    <span class="availability" v-if="mentor.status==='available'">Available to mentor {{availableDays}}, {{availableTimes}}, {{venue}}</span>
                    <ul class="specialties">
                        <li v-for="specialty in mentor.specialties">
                            {{specialty | deslugify}}
                        </li>
                    </ul>
                    <div class="public-status" v-if="localStorage.roles.includes('OnlineDirector') || localStorage.roles.includes('CampusDirector')">
                    <label><input type="checkbox" v-model="mentor.public" @change="updateMentor()"> Visible on Public Website</label>
<!-- v-if="
                            mentor.status === 'available'
                            && mentor.user.mentees.length < mentor.seats"-->

                    </div>        
                    <button
                        :class="{'disabled': !connectionAllowed}"
                        v-if="mentor.status === 'available' && isCorrectVenue && mentor.user.mentees.length < mentor.seats"
                        class="connect"
                        v-tooltip="tooltipText"
                        @click.prevent="connectToMentor()">
                        Connect
                    </button>
                    <div class="current-mentees">
                        <span>Mentees Confirmed:</span>
                        <div v-for="a in mentor.availabilities" class="term-availability">
                            <div>
                                {{a.term.name.split(',')[1].trim()}}
                            </div>
                            <div>
                                <ul v-if="a.status === 'available'">
                                    <li v-for="n in a.seats">
                                        <span class="checkbox">
                                            <i :class="{'green':(n-1) < a.connections.length}" class="fa fa-check"></i>
                                        </span>
                                    </li>
                                </ul>
                                <ul v-else-if="a.status === 'unavailable'">
                                    <li v-for="n in a.seats">
                                        <span class="checkbox" title="Mentor is not available for this term">
                                            <i class="fa fa-remove red"></i>
                                        </span>
                                    </li>
                                </ul>
                               

                            </div>
                        </div>
                        <!-- <ul>
                            <li v-for="n in mentor.seats">
                        <span class="checkbox">
                            <i :class="{'green':(n-1) < mentor.user.mentees.length}" class="fa fa-check"></i>
                        </span>
                        </li>
                        </ul> -->
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-xs-4">
                    <h3>Biography</h3>
                    <div class="bio" v-html="mentor.bio">                        
                    </div>
                    <ul class="links">
                        <li v-for="site in mentor.socialSites">
                            <a :href="site.url" target="_blank">{{site.site}}</a>
                        </li>
                    </ul>
                </div>
                <div class="col-xs-8">
                    <vue-media-embed v-if="mentor.demoReelUrl && demoReelAccessible" :source="mentor.demoReelUrl" :allow-fullscreen="1" />
                    <img v-else :src="mentor.featuredImage">
                </div>
            </div>
            <div class="row" v-if="mentor.gallery.length > 0">
                <br>
                <h3>Work Samples</h3>
                <ul class="gallery work-samples">
                    <li v-for="(image, $index) in mentor.gallery" @click="openLightbox(mentor.gallery, $index)">
                        <v-lazy-image :src="image" />
                    </li>
                </ul>
            </div>
            <div class="row" v-if="mentor.credits.length > 0">
                <br>
                <h3>Credits Include</h3>
                <ul class="gallery credits">
                    <li v-for="(image, $index) in mentor.credits" @click="openLightbox(mentor.credits, $index)">
                        <v-lazy-image :src="image" />
                    </li>
                </ul>
            </div>
            <div class="row" v-if="mentor.pastMentoredStudents.length > 0">
                <h3>Past Mentored Students</h3>
                <ul class="past-students">                    
                    <li v-for="student in mentor.pastMentoredStudents">                        
                        <div class="header">
                            <div class="avatar-wrapper">
                                <img class="avatar" :src="student.avatar">
                            </div>
                            <div class="meta">                                
                                <h4>{{student.name}}</h4>
                                <ul v-if="student.artstation" class="links">
                                    <li>
                                        <a :href="student.artstation" target="_blank">{{student.artstation}}</a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div>                            
                            
                            <ul class="images">
                                <li v-for="(image, $index) in student.images" @click="openLightbox(student.images, $index)">
                                    <img :src="image">
                                </li>
                            </ul>
                        </div>
                    </li>

                </ul>
            </div>
        </div>
        <div class="lightbox" @click="lightboxImages=null" v-if="lightboxImages"><i class="fa fa-remove" @click="lightboxImages=null"></i>
            <swiper :options="swiperOption" ref="lightbox">
                <swiper-slide v-for="slide in lightboxImages">
                    <img :src="slide">
                </swiper-slide>
                <div @click.stop class="swiper-button-prev swiper-button-white" slot="button-prev"></div>
                <div @click.stop class="swiper-button-next swiper-button-white" slot="button-next"></div>
            </swiper>
        </div>
    </section>
</template>
<script>
import mentors from '../services/mentors';

import toastr from 'toastr';
import axios from 'axios';
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import linkifyHtml from 'linkifyjs/html';
import VLazyImage from 'v-lazy-image/v2';

export default {
    data() {
        return {
            mentorId: this.$route.params.id,
            mentor: null,
            connect: false,
            demoReelAccessible: false,
            lightboxImages: null,
            request: 'Send a message to your mentor why you’d want to work with him/her and don’t forget to include links to your work online (artstation) or your Portal galleries (https://portal.tttc.ca/#/galleries?author=70).\r\n\r\nBe sure to mention that you are a campus or online student as sometimes mentors do both, be very clear!\r\n\r\n“Dear [Insert Mentor Name],\r\n\r\nMy Mentorship begins in [insert Feb, June or Oct] [at Campus or Online].\r\n\r\nI would like to mentor with you because [insert reason].\r\n\r\nHere is a collection of my recent work [insert recent work link].\r\n\r\nPlease let me know, I’m looking forward to working with you.\r\n\r\nRespectfully,\r\n[Insert Your Name]”',
            swiperOption: {
                keyboard: {
                    enabled: true
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev'
                }
            },


        }
    },
    components: {
        swiper,
        swiperSlide,
        VLazyImage
    },
    mounted() {
        this.getMentor();        
    },
    methods: {
        updateMentor() {
            const update = {
                public: this.mentor.public,
                id: this.mentor.id
            }
            mentors.togglePublic(update).then((response)=>{
                response.data.success === true ? toastr.success('Updated') : toastr.error('Error updating');
            });            
        },
        getMentor() {
            mentors.getProfile(this, this.mentorId).then((response) => {
                this.mentor = response.data.profile;
                const now = new Date();

                this.mentor.availabilities = this.mentor.mentor_availabilities.slice(0, 2)
                    .filter(a => a.status === 'available' || a.status === 'unavailable')
                    .map((a) => {
                    console.log(a.term.id)
                    a.connections = this.mentor.user.mentor_requests.filter((r)=>{
                        return r.term === a.term.id && r.approvedByMentor && r.approvedByStudent;
                    });
                    
                    return a;
                });        
                console.log(this.mentor.availabilities)           


                if (!this.mentor.user.mentees) this.mentor.user.mentees = [];
                if (this.mentor.bio) { this.mentor.bio = linkifyHtml(this.mentor.bio); }
                if (this.mentor.demoReelUrl) {
                    if (this.mentor.demoReelUrl.includes('vimeo')) {
                        axios.head('https://vimeo.com/api/oembed.json?url=' + this.mentor.demoReelUrl).then((r)=>{
                            if (r.status.toString().startsWith('2')) {
                                this.demoReelAccessible = true;
                            }
                        }).catch((e)=>{
                            // video was deleted or set to private
                        })
                    } else if (this.mentor.demoReelUrl.includes('youtube') || this.mentor.demoReelUrl.includes('youtu.be')) {
                        axios.head('https://www.youtube.com/oembed?url=' + this.mentor.demoReelUrl).then((r)=>{
                            console.log(r)
                            if (r.status.toString().startsWith('2')) {
                                this.demoReelAccessible = true;
                            }
                        }).catch((e)=>{
                            // video was deleted or set to private
                        })
                    }
                }
            });
        },
        connectToMentor() {
            if (!this.connectionAllowed) return;

            if ((this.mentor.user.mentees.length + 1) > this.mentor.seats) {
                toastr.error('This mentor already has the maximum number of students');
                return;
            }
            this.connect = true;
        },
        sendRequest() {
            var self = this;
            let data = {
                mentorId: this.mentor.userId,
                text: this.request
            }
            mentors.request(this, data).then(function(response) {
                if (response.data.success === true) {
                    toastr.success('Request sent');

                } else {
                    toastr.error(response.data.message);
                }
            });
        },
        openLightbox(images, index) {
            var self = this;
            this.lightboxImages = images;
            this.$nextTick(function() {
                self.$refs.lightbox.swiper.slideTo(index, 0);
            })
        }
    },
    computed: {
        isCorrectVenue() {
            let allowed = true;
            const roles = JSON.parse(localStorage.roles);   
            if (this.mentor.nextTermVenue === 'campus') {
                if (roles.includes('Student') && localStorage.transitioned != 'true') {
                    allowed = false;
                }
            }
            return allowed;
        },
        tooltipText() {
            if (!this.connectionAllowed) return 'Mentor selections will be made available to you at a later date. Check your Journey page for details.';
            return null;
        },

        connectionAllowed() {
            const settings = this.$store.getters.settings;
            let allowed = false;

            if (settings && settings.length > 0) {
                let overrides = settings.find((s)=>{return s.name=== 'mentorSelectorOverride'}).data;
                const overridden = overrides.includes(parseInt(localStorage.user_id));
                let setting;
                if (localStorage.roles.includes('CampusStudent') || localStorage.transitioned == 'true') {
                    setting = settings.find((s)=>{return s.name=== 'campusMentorSelectionAllowed'}).value;
                } else {
                    setting = settings.find((s)=>{return s.name=== 'onlineMentorSelectionAllowed'}).value;
                }
                let studentGroups = localStorage.group.split(',');
                let inCampusMentorshipGroup = (studentGroups.includes('21'));
                if (setting === true && (overridden === true || localStorage.terms.split(',').length === 3 || (localStorage.roles.includes('CampusStudent') && inCampusMentorshipGroup))) {
                    allowed = true;
                }
            }

            if (this.mentor.nextTermVenue === 'campus') {
                const roles = JSON.parse(localStorage.roles);                
                if (roles.includes('Student') && localStorage.transitioned != 'true') {
                    allowed = false;
                }
            }

          
            return allowed;
        },

        availableDays() {
            if (this.mentor.availableDays === 'both') return 'weekdays and weekends';
            return this.mentor.availableDays;
        },
        availableTimes() {
            if (this.mentor.availableTimes === 'any') return 'any time';
            return 'in the ' + this.mentor.availableTimes;
        },
        venue() {
            if (this.mentor.nextTermVenue === 'both') return 'on Campus and Online';
            if (this.mentor.nextTermVenue === 'campus') return 'on Campus';
            if (this.mentor.nextTermVenue === 'online') return 'Online';
        }
    }
}

</script>
<style lang="scss">
.mentor-profile .swiper-wrapper {
    height: 100vh;

    .swiper-slide {
        display: flex;
        align-items: center;
        justify-content: center;
    }
}

</style>
<style lang="scss" scoped>
.panel {
    background: #0f0f0f;
}

.mentor-header {
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    position: relative;
    height: 160px;
    margin-bottom: 2rem;

    &>div {
        position: relative;
        z-index: 999;
        height: 160px;
    }

    .col-xs-2 {
        padding: 0;
    }

    .col-xs-10 {
        position: relative;
    }

    .current-mentees {
        position: absolute;
        bottom: 0;
        right: 0;
        max-width: 400px;
        background: rgba(0, 0, 0, .45);
        padding: .35rem 1rem;

        ul {
            display: flex;
            align-items: center;
            justify-content: space-around;
            background: transparent;
        }

        li {
            padding: 0 .5rem;
            background: transparent;
        }
        .term-availability {
            display: flex;
            align-items:center;
        }
        .checkbox {
            position: relative;
            border: 2px solid #444;
            background: transparent;
            width: 16px;
            height: 16px;
        }

        .fa-check {
            color: #444;
            font-size: 18px;
            position: absolute;
            top: -2px;
            left: -2px;

            &.green {
                color: #2DA21D;
            }
        }
        .fa-remove {
            font-size: 18px;
            position:absolute;
            top:-2px;
            left:-1px;
            &.red {
                color:red;
            }
        }
        .unconfirmed {
            font-size:12px;            
            padding-left:.5rem;
            opacity:.65;
        }
    }

    .avatar {
        width: 160px;
        height: 160px;
        object-fit: cover;
    }
}

.mentor-header::after {
    display: block;
    position: relative;
    background-image: linear-gradient(to left, rgba(50, 50, 50, .55) 0, #222 70%);
    top: -160px;
    height: 160px;
    width: 100%;
    content: '';
    z-index: 9;
}

.name,
.position,
.company {
    display: inline-block;
}

.availability {
    display: block;
}

.name,
.availability,
.position,
.company {

    font-size: 2rem;
    font-weight: 300;
}

.name {
    color: #fafafa;
    font-size: 18pt;

}

.availability {
    color: #b0b0b0;
}

.position {
    color: #fafafa;
}

.fa-remove {
    z-index: 9999999;
}

.past-students {
    .avatar-wrapper {
        display:flex;
        justify-content:center;
        img {
            max-height:200px;
            object-fit:cover;
        }
    }
    .header {
        padding:1rem;
        display:flex;
        & > div {
            width:50%;
            

        }
        .meta {
            display:flex;
            align-items:center;
            justify-content:center;
            flex-direction:column;
            padding:2rem;
        }
    }
    .links {
        text-align:center;
    }
    .images {
        display: flex;
        justify-content:center;
        li {
            width:25%;
            padding:1rem;
            img {
                height:320px;
                width:100%;
                object-fit:cover;
                cursor:pointer;
            }
        }
    }
    
}

h3 {
    font-size: 18pt;
    color: #fafafa;
    font-weight: 300;
    margin: 1rem 0 2rem 0;
}

a {
    text-decoration: underline;
}

.connect {
    background: #33ccff;
    position: absolute;
    top: 0;
    right: 0;
    color: #000;
    padding: .8rem 1.5rem;
    border: none;
    &.disabled {
          background: #666;
          opacity: .5;
          cursor:default;
          cursor: default;
    }
}

.specialties {
    display: flex;
    flex-wrap: wrap;
    max-width: 80%;

    //max-height: 40px;
    //justify-content:center;
    li {
        margin: .5rem 1rem .5rem 0;
        padding: .25rem 1rem;
        border: 1px solid #777;
    }
}

.bio {
    margin-bottom: 1rem;
}

.links {
    margin-top: 1rem;
}

.gallery {
    display: flex;
    flex-wrap: wrap;

    li {
        width: 33.3333%;
        padding: 1rem;
        cursor: pointer;
    }

    &.credits li {
        width: 20%;
        padding: 0;
        margin-right: 1rem;
    }
}

.work-samples {
    img {
        width:100%;
        height:240px;
        object-fit:cover;
    }
}

.modal-wrapper {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 999999;
    background: rgba(0, 0, 0, .75);
    display: flex;
    align-items: center;
    justify-content: center;

    .modal-box {
        width: 500px;
        height: 550px;
        border: 1px solid #fff;
        text-align: center;
        border: 3px solid #111;
        background: #555;
        position: relative;
        background-position: center center;
        background-size: cover;
        background-repeat: no-repeat;

        &::after {
            display: block;
            content: '';
            background: rgba(50, 50, 50, .75);
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            z-index: 1;
        }

        textarea {
            height: 350px;
            border: 2px solid black;
            box-shadow: inset 0px 0px 190px rgba(0, 0, 0, .5);
        }

        textarea,
        img,
        button,
        h3 {
            z-index: 999;
            position: relative;
        }
    }

    h3 {
        margin-top: -60px;
    }

    .avatar {
        width: 150px;
        height: 150px;
        object-fit: cover;
        position: relative;
        top: -75px;
        border: 3px solid #111;
    }

    textarea {
        resize: none;
        width: 400px;
        height: 350px;
        background: #333;
        color: #fafafa;
        padding: 10px;
    }

    button {
        margin-top: 1rem;
        padding: 5px 20px;
        border: 1px solid #3cf;

    }

}

</style>



// WEBPACK FOOTER //
// MentorProfile.vue?34933a28